
const logRequest = (response) => {
    console.log(`HTTP response status code ${response.status}`);
    console.log(`HTTP response status text ${response.statusText}`);
    console.log(`HTTP response url ${response.url}`);
    console.log(`HTTP response headers`, response.headers);
}

const validResponseContentType = (response) => {
    console.log('Response headers');
    for (const pair of response.headers.entries()) {
        console.log(`${pair[0]}: ${pair[1]}`);
        if(pair[0] === 'content-type' && pair[1] === 'application/json') {
            return true;
        }
    }
    return false;
}

const getCsrfToken = () => {
    const csrfCookie = document.cookie
        .split('; ')
        .find(cookie => cookie.startsWith('csrftoken='));

    return csrfCookie ? csrfCookie.split('=')[1] : null;
}

const postFile = async (file, user) => {
    const databaseUrl = "https://claim3-cpp.onrender.com/";
    console.log(`Uploading filename ${file.name}`);
    const formData = new FormData();
    formData.append('file', file)
    const auth = btoa(`${user.username}:${user.password}`);
    const response = await fetch(`${databaseUrl}file_upload/`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Authorization': `Basic ${auth}=`,
            },
            body: formData,
            credentials: 'include',
    });
    logRequest(response);
    const jsonResponse = validResponseContentType(response);;
    let jsonResponsePayload = null;
    if (jsonResponse) {
        jsonResponsePayload = await response.json();
        console.log(jsonResponsePayload);
    }
    if (response.ok) {
        console.log('request succeeded');
        return {
            filename: file.name,
            status: true,
            code: response.status,
            message: 'Success'
        }
    }
    if (response.status >= 300 && response.status < 400) {
        console.error(`${file.name} failed due to redirect 3xx response`)
        return {
            filename: file.name,
            status: false,
            code: response.status,
            message: 'Redirects not allowed'
        }
    }
    if (response.status >= 400 && response.status < 500) {
        if (jsonResponse) {
            console.error(`${file.name} failed with response message ${jsonResponsePayload.message}`);
            return {
                filename: file.name,
                status: false,
                code: response.status,
                message: jsonResponsePayload.message
            }
        }
        console.error(`Failed to upload ${file.name}`)
        return {
            filename: file.name,
            status: false,
            code: response.status,
            message: 'Client request error'
        }
    }
    if (response.status >= 500) {
        console.error(`Unable to upload ${file.name}`)
        return {
            filename: file.name,
            status: false,
            code: response.status,
            message: 'Server response error'
        }
    }
}

const registerUser = async (userData) => {
    const registerUrl = "https://claim3-cpp.onrender.com/";
    const csrfToken = getCsrfToken();

    const response = await fetch(`${registerUrl}sign_up/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify(userData),
    });

    logRequest(response);
    const jsonResponse = validResponseContentType(response);
    let jsonResponsePayload = null;

    if (jsonResponse) {
        jsonResponsePayload = await response.json();
        console.log(jsonResponsePayload);
    }

    if (response.ok) {
        console.log('Registration successful');
        return {
            status: true,
            code: response.status,
            message: 'Registration successful',
            userId: jsonResponsePayload.user_id,
        };
    } else {
        console.error('Registration failed');
        return {
            status: false,
            code: response.status,
            message: jsonResponsePayload ? jsonResponsePayload.message : 'Registration failed',
        };
    }
};


const loginUser = async (userData) => {
    const loginUrl = "https://claim3-cpp.onrender.com/";
    const csrfToken = getCsrfToken();

    const response = await fetch(`${loginUrl}user_login/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify(userData),
    });

    logRequest(response);
    const jsonResponse = validResponseContentType(response);
    let jsonResponsePayload = null;

    if (jsonResponse) {
        jsonResponsePayload = await response.json();
        console.log(jsonResponsePayload);
    }

    if (response.ok) {
        console.log('Sign in successful');
        return {
            status: true,
            code: response.status,
            message: 'Sign in successful',
        };
    } else {
        console.error('Sign in failed');
        return {
            status: false,
            code: response.status,
            message: jsonResponsePayload ? jsonResponsePayload.message : 'Sign in failed',
        };
    }
};


export default {postFile, registerUser, loginUser};
